import { addEventListeners } from "../utils/dom";

export default class DonationCustomerType extends HTMLFieldSetElement {

    connectedCallback() {

        addEventListeners(this.radioElements, "change", this.handleChange);
        
    }

    disconnectedCallback() {

        // Remove any event handlers and such here

    }

    handleChange = (e) => {
        const selectedOption = e.target;

        if (selectedOption.value === "1") {
            this.companyAmountElement.classList.add("d-none");
            this.personalAmountElement.classList.remove("d-none");
        }
        else {
            this.companyAmountElement.classList.remove("d-none");
            this.personalAmountElement.classList.add("d-none");
        }
    }

    get personalAmountElement() {
        return document.querySelector(this.dataset.targetPersonal);
    }

    get companyAmountElement() {
        return document.querySelector(this.dataset.targetCompany);
    }

    get radioElements() {
        return this.querySelectorAll("input[type=radio]");
    }

}

customElements.define('donation-customer-type', DonationCustomerType, { extends: 'fieldset' });